import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { StatusEnum } from "../../../../../../commons/enums/status-enum";
import { manageFootballTeamService } from "../../../../../../commons";

interface ITeamManagerRemoveState {
  manageTeamManagerRemoveStatus: StatusEnum;
}

const initialState: ITeamManagerRemoveState = {
  manageTeamManagerRemoveStatus: StatusEnum.Idle,
};

export interface ITeamManagerRemoveOption {
  teamId: number;
  managerId: number;
}

export const teamManagerRemove = createAsyncThunk(
  "manage/teamManagerRemove",
  async (options: ITeamManagerRemoveOption, thunkAPI) => {
    try {
      const teamManagerRemoveResponse = await manageFootballTeamService.removeTeamManager(
        options.teamId,
        options.managerId
      );
      return teamManagerRemoveResponse;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const manageTeamManagerRemoveSlice = createSlice({
  name: "teamManagerRemove",
  initialState: initialState,
  reducers: {
    cleanUpTeamManagerRemove(state) {
      state.manageTeamManagerRemoveStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(teamManagerRemove.pending, (state) => {
        state.manageTeamManagerRemoveStatus = StatusEnum.Loading;
      })
      .addCase(teamManagerRemove.fulfilled, (state, action) => {
        state.manageTeamManagerRemoveStatus = StatusEnum.Succeeded;
      })
      .addCase(teamManagerRemove.rejected, (state) => {
        state.manageTeamManagerRemoveStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpTeamManagerRemove } = manageTeamManagerRemoveSlice.actions;
export default manageTeamManagerRemoveSlice.reducer;
